// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__soohn","controls":"styles_controls__sz4uG","charLimit":"styles_charLimit__O8bnq","input":"styles_input__19G3D","send":"styles_send__mjajy"};